/*
	This mixin is used to handle the display of failure and success message.

	The messages can be the default one present in the DS translation files
	or customized one passed through props.
*/

import _isEmpty from 'lodash/isEmpty';
import _flatten from 'lodash/flatten';
import _uniq from 'lodash/uniq';

export default {
	props: {
		displayMessage: {
			type: Boolean,
			required: false,
			default: true,
		},

		errors: {
			type: Object,
			required: false,
			default: () => null,
			validator: (errors) => {
				// The errors props must have languages as keys in order to work properly
				const supportedLanguages = ['fr', 'en'];
				let isValid = true;

				supportedLanguages.forEach((language) => {
					if (errors && !_isEmpty(errors) && !errors[language]) {
						isValid = false;
					}
				});

				return isValid;
			},
		},

		failureMessage: {
			type: Object,
			required: false,
			default: () => null,
			validator: message => !message || message.title || message.text,
		},

		messageOffset: {
			type: Number,
			required: false,
			default: 15,
		},

		successMessage: {
			type: Object,
			required: false,
			default: () => null,
			validator: message => !message || message.title || message.text,
		},
	},

	data() {
		return {
			message: {},
		};
	},

	watch: {
		state() {
			if (this.state === 'success' && this.displayMessage) {
				this.changeMessage('success', this.successMessage, this.$t('form.message.success'));
			} else if (this.state === 'failure' && this.displayMessage) {
				this.changeMessage('danger', this.failureMessage, this.$t('form.message.failure'));
			} else {
				this.removeMessage();
			}
		},
	},

	computed: {
		hasMessage() {
			return this.message && this.message.title && this.message.state;
		},

		flattenedErrors() {
			const errors = [];
			const abbreviations = ['fr', 'en'];

			if (this.errors && this.errors[this.$i18n.locale]) {
				const currentErrors = this.errors[this.$i18n.locale];

				Object.keys(currentErrors).forEach((key) => {
					let error = currentErrors[key];

					abbreviations.forEach((abbreviation) => {
						if (key.includes(`.${abbreviation}.`)) {
							const context = this.$t(`form.message.errors.context.${abbreviation}`);
							error += ` <b>${context}<b>`;
						}
					});

					errors.push(error);
				});
			}

			return _uniq(_flatten(Object.values(errors)));
		},
	},

	methods: {
		changeMessage(state, customMessage, fallbackMessage) {
			// Display message either the custom one passed through props
			// or the default one defined in the translation files
			let { title, text } = fallbackMessage;

			if (customMessage && customMessage.title) {
				({ title } = customMessage);
			}

			if (customMessage && customMessage.text) {
				({ text } = customMessage);
			}

			this.message = { state, title, text };

			// Scroll to the Message component
			this.$nextTick(() => {
				if (this.$refs.message) {
					this.$scrollTo(this.$refs.message, 1000, {
						offset: (this.messageOffset * -1),
					});
				}
			});
		},

		removeMessage() {
			this.message = {};
		},
	},
};
